import { useTranslation } from 'react-i18next';
import StaggerReveal from '../../../components/feature/StaggerReveal';

function TestimonialCard({ t_name, t_initials, t_rating, t_role, t_company, t_industry, t_quote }: { t_name: string; t_initials: string; t_rating: number; t_role: string; t_company: string; t_industry: string; t_quote: string }) {
  return (
    <div className="bg-navy-800 border border-navy-600 hover:border-electric/30 hover:-translate-y-1 rounded-2xl p-5 md:p-7 transition-all duration-300 cursor-default flex flex-col">
      <div className="flex items-center gap-1 mb-4">
        {Array.from({ length: t_rating }).map((_, i) => (
          <div key={i} className="w-4 h-4 flex items-center justify-center text-yellow-400">
            <i className="ri-star-fill text-sm"></i>
          </div>
        ))}
        <span className="font-body text-xs text-electric ml-2 font-semibold">{t_industry}</span>
      </div>
      <div className="w-6 h-6 flex items-center justify-center text-electric/30 mb-2">
        <i className="ri-double-quotes-l text-3xl"></i>
      </div>
      <p className="font-body text-white/75 text-sm leading-relaxed mb-6 italic flex-1">
        &ldquo;{t_quote}&rdquo;
      </p>
      <div className="flex items-center gap-3 pt-4 border-t border-navy-700">
        <div className="w-11 h-11 rounded-full flex-shrink-0 bg-electric/15 border border-electric/30 flex items-center justify-center">
          <span className="font-heading text-sm font-bold text-electric">{t_initials}</span>
        </div>
        <div>
          <div className="font-heading text-sm font-bold text-white">{t_name}</div>
          <div className="font-body text-xs text-electric/80 font-semibold">{t_role}</div>
          <div className="font-body text-xs text-white/45">{t_company}</div>
        </div>
      </div>
    </div>
  );
}

export default function Testimonials() {
  const { t } = useTranslation();

  const testimonials = [
    { name: 'Wascar D.', initials: 'WD', rating: 5, role: t('test_1_role'), company: t('test_1_company'), industry: t('test_1_industry'), quote: t('test_1_quote') },
    { name: 'Lisaury P.', initials: 'LP', rating: 5, role: t('test_2_role'), company: t('test_2_company'), industry: t('test_2_industry'), quote: t('test_2_quote') },
    { name: 'Omar M.', initials: 'OM', rating: 5, role: t('test_3_role'), company: t('test_3_company'), industry: t('test_3_industry'), quote: t('test_3_quote') },
    { name: 'Héctor R.', initials: 'HR', rating: 5, role: t('test_4_role'), company: t('test_4_company'), industry: t('test_4_industry'), quote: t('test_4_quote') },
  ];

  return (
    <section id="testimonials" className="bg-navy-900 py-14 md:py-24 px-5 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <span className="inline-block text-electric text-xs md:text-sm font-semibold tracking-widest uppercase font-body mb-2 md:mb-3">{t('test_label')}</span>
          <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 md:mb-4">
            {t('test_title_1')} <span className="text-electric">{t('test_title_accent')}</span>
          </h2>
          <p className="font-body text-white/60 text-sm md:text-base max-w-xl mx-auto">
            {t('test_sub')}
          </p>
        </div>
        <StaggerReveal
          className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-5xl mx-auto"
          staggerDelay={130}
        >
          {testimonials.map((test) => (
            <TestimonialCard
              key={test.name}
              t_name={test.name}
              t_initials={test.initials}
              t_rating={test.rating}
              t_role={test.role}
              t_company={test.company}
              t_industry={test.industry}
              t_quote={test.quote}
            />
          ))}
        </StaggerReveal>
      </div>
    </section>
  );
}
